export default __webpack_public_path__ + "4856e608e045077a342fc55a55baa32c.jpg";